import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import SocialLinks from "./footer/SocialLinks";
import FooterNavColumn from "./footer/FooterNavColumn";

import { socialLinks, navColumns } from "./footer/FooterData";

const Footer = () => {
  const isMobile = useIsMobile();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-sage-900 text-sage-100 pt-8 pb-4 sm:pt-12 sm:pb-6 md:pt-16 md:pb-8">
      <div className="container px-4 sm:px-6 lg:px-8">
        {/* Main footer grid with responsive layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 mb-8 sm:mb-10">
          {/* Brand section */}
          <div className="lg:col-span-4 xl:col-span-3 flex flex-col">
            <h4 className="font-heading text-lg sm:text-xl mb-3 sm:mb-4 text-sage-50">Jörg Hörmann</h4>
            <p className="text-sage-300 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed">
              Finanzcoach & Consultant<br />
              Für einen selbstbestimmten Umgang mit Geld und Finanzen
            </p>
            
            <SocialLinks links={socialLinks} />
            
            {/* RSS Feed Link */}
            <a 
              href="/rss.xml" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sage-300 hover:text-sage-50 transition-colors mt-4 text-sm group"
              aria-label="RSS-Feed abonnieren"
            >
              <svg 
                className="w-5 h-5 group-hover:scale-110 transition-transform" 
                fill="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6.503 20.752c0 1.794-1.456 3.248-3.251 3.248-1.796 0-3.252-1.454-3.252-3.248 0-1.794 1.456-3.248 3.252-3.248 1.795.001 3.251 1.454 3.251 3.248zm-6.503-12.572v4.811c6.05.062 10.96 4.966 11.022 11.009h4.817c-.062-8.71-7.118-15.758-15.839-15.82zm0-3.368c10.58.046 19.152 8.594 19.183 19.188h4.817c-.03-13.231-10.755-23.954-24-24v4.812z"/>
              </svg>
              <span>RSS-Feed abonnieren</span>
            </a>
          </div>
          
          {/* Navigation columns with improved responsive grid */}
          <div className="lg:col-span-8 xl:col-span-9">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {navColumns.map((column, index) => (
                <FooterNavColumn key={index} title={column.title} items={column.items} />
              ))}
            </div>
          </div>
        </div>

        {/* Privacy notice */}
        <div className="border-t border-sage-800 pt-4 sm:pt-6 mb-4 flex justify-center">
          <p className="text-sage-400 text-xs sm:text-sm text-center leading-relaxed max-w-2xl">
            🔒 Ihre Privatsphäre ist uns wichtig. Diese Website folgt dem Prinzip Privacy by Design: kein Tracking, keine Analyse-Cookies, keine Drittanbieter-Tracker. Ein Cookie-Einwilligungsbanner ist daher gemäß DSGVO/TTDSG nicht erforderlich.
          </p>
        </div>

        {/* Clean bottom section */}
        <div className="border-t border-sage-800 pt-4 sm:pt-6">
          <div className="flex flex-col items-center justify-center gap-2 sm:gap-3">
            <div className="text-center">
              <p className="text-sage-400 text-xs sm:text-sm leading-relaxed">
                <span className="block sm:inline">© {currentYear} Jörg Hörmann Coaching & Consulting</span>
                <span className="hidden sm:inline"> | </span>
                <span className="block sm:inline">Grimmstr. 15, 91154 Roth</span>
                <span className="hidden sm:inline"> | </span>
                <span className="block sm:inline">joerg-hoermann.de</span>
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
